module.exports = __webpack_public_path__ + "static/media/synth-awww.9f644d3c.webm";